import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost, apiPostQuery, apiPatch, apiDelete } from 'api'
import AuthContext from 'context/auth-context'


const createDashboardEmployee = async (token, params, id) => {
  const objectName = 'dashboard_employee'
  const url = `dashboards/${id}/dashboard_employees`

  const data = await apiPost({ url, token, objectName, params })
  return data
}

export function useCreateDashboardEmployee({ params, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    () => {
      return createDashboardEmployee(token, params, params.dashboard_id)
    },
    { ...options }
  )
}

const updateDashboardEmployee = async (token, params, id) => {
  const objectName = 'dashboard_employee'
  const url = `dashboard_employees/${id}`

  const data = await apiPatch({ url, token, objectName, params })
  return data
}

export function useUpdateDashboardEmployee({ options }) {
  const token = useContext(AuthContext)

  return useMutation(
    (params) => {
      return updateDashboardEmployee(token, params, params.dashboard_employee_id)
    },
    { ...options }
  )
}

const deleteDashboardEmployee = async (token, id) => {
  const url = `dashboard_employees/${id}`

  const data = await apiDelete({ url, token })
  return data
}

export function useDeleteDashboardEmployee({ id, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    () => {
      return deleteDashboardEmployee(token, id)
    },
    { ...options }
  )
}

const bulkCreateDashboardEmployees = async (token, dashboardId, employees, options = 'include') => {
  const url = `dashboards/${dashboardId}/dashboard_employees/bulk_create`
  const data = await apiPostQuery({ url, token, params: { employees, options } })
  return data
}

export function useBulkCreateDashboardEmployees({ options }) {
  const token = useContext(AuthContext)

  return useMutation(
    ({ dashboardId, employees, options: employeeOptions }) => {
      return bulkCreateDashboardEmployees(token, dashboardId, employees, employeeOptions)
    },
    { ...options }
  )
}

const bulkDestroyDashboardEmployees = async (token, dashboardId, databaseColumnName) => {
  let url = `dashboards/${dashboardId}/dashboard_employees/bulk_destroy`
  if (databaseColumnName) {
    url += `?database_column_name=${encodeURIComponent(databaseColumnName)}`
  }
  const data = await apiDelete({ url, token })
  return data
}

export function useBulkDestroyDashboardEmployees({ options }) {
  const token = useContext(AuthContext)

  return useMutation(
    ({ dashboardId, databaseColumnName } = {}) => {
      return bulkDestroyDashboardEmployees(token, dashboardId, databaseColumnName)
    },
    { ...options }
  )
}
